var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWoosmapWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 35.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.893,11.2h2.238l3.032,11.07L69.436,11.2h2.239l3.2,11.094L77.86,11.2h2.166L75.91,24.392H73.648L70.471,13.923,67.294,24.392H65.032Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.944,24.609c-3.73,0-6.57-2.648-6.57-6.835a6.668,6.668,0,1,1,13.333,0A6.54,6.54,0,0,1,87.944,24.609Zm0-1.926c2.286,0,4.524-1.564,4.524-4.909,0-3.322-2.19-4.886-4.452-4.886-2.31,0-4.4,1.564-4.4,4.886C83.612,21.119,85.658,22.683,87.944,22.683Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.347,24.609c-3.73,0-6.57-2.648-6.57-6.835a6.667,6.667,0,1,1,13.332,0A6.539,6.539,0,0,1,103.347,24.609Zm0-1.926c2.286,0,4.524-1.564,4.524-4.909,0-3.322-2.19-4.886-4.452-4.886-2.31,0-4.4,1.564-4.4,4.886C99.015,21.119,101.061,22.683,103.347,22.683Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.667,24.609c-3.081,0-5.247-1.685-5.391-4.092h2.262c.121,1.276,1.252,2.239,3.105,2.239,1.732,0,2.695-.867,2.695-1.95,0-2.936-7.8-1.227-7.8-6.137,0-2.021,1.9-3.682,4.837-3.682,2.912,0,4.837,1.564,4.982,4.139h-2.19c-.1-1.323-1.107-2.286-2.864-2.286-1.613,0-2.575.77-2.575,1.829,0,3.129,7.653,1.42,7.749,6.137C122.48,22.972,120.579,24.609,117.667,24.609Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.6,16.931c0-2.695-1.444-4.067-3.61-4.067-2.214,0-3.73,1.42-3.73,4.26v7.268h-2.166V16.931c0-2.695-1.444-4.067-3.61-4.067-2.214,0-3.73,1.42-3.73,4.26v7.268h-2.19V11.2h2.19v1.9a4.766,4.766,0,0,1,4.163-2.142,4.961,4.961,0,0,1,4.837,2.936,4.884,4.884,0,0,1,4.669-2.936c3.009,0,5.343,1.877,5.343,5.656v7.773H144.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.789,10.987A5.471,5.471,0,0,1,160.7,13.61V11.2h2.215V24.392H160.7V21.937a5.508,5.508,0,0,1-4.933,2.672c-3.514,0-6.233-2.768-6.233-6.859C149.532,13.634,152.251,10.987,155.789,10.987Zm.433,1.9c-2.407,0-4.452,1.757-4.452,4.862s2.045,4.933,4.452,4.933,4.476-1.8,4.476-4.909C160.7,14.717,158.629,12.888,156.222,12.888Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.743,10.987c3.537,0,6.257,2.647,6.257,6.763,0,4.091-2.72,6.859-6.257,6.859a5.7,5.7,0,0,1-4.934-2.648v8.688h-2.19V11.2h2.19v2.43A5.571,5.571,0,0,1,173.743,10.987Zm-.457,1.9a4.533,4.533,0,0,0-4.477,4.886c0,3.1,2.094,4.909,4.477,4.909,2.43,0,4.476-1.829,4.476-4.933S175.716,12.888,173.286,12.888Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.839,
    width: 7.731,
    height: 7.987,
    fill: "#fff",
    opacity: 0.66
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.718,
    y: 7.987,
    width: 11.852,
    height: 7.731,
    fill: "#fff",
    opacity: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.987,
    y: 7.987,
    width: 7.731,
    height: 11.853,
    fill: "#fff",
    opacity: 0.85
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 19.84,
    width: 15.718,
    height: 7.731,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.496,
    y: 8.201,
    width: 7.988,
    height: 7.731,
    fill: "#fff",
    opacity: 0.66
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.765,
    y: 8.201,
    width: 7.731,
    height: 11.853,
    fill: "#fff",
    opacity: 0.75
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27.643,
    y: 20.054,
    width: 11.852,
    height: 7.731,
    fill: "#fff",
    opacity: 0.85
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.912,
    y: 20.054,
    width: 7.731,
    height: 15.718,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoosmapWhiteLogo);
export default __webpack_public_path__ + "static/media/woosmap-white-logo.601a815e76a394c5805bdcc38ed37fc8.svg";
export { ForwardRef as ReactComponent };